import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useDispatch } from 'react-redux';
import { apiMethods } from '~/services/api';
import { apiMethodsConst } from '~/services/methods';
import type { IProcedureEndorsementPayload } from '../Types';

type TSendProcedureEndorsementResponse = unknown;
type TSendProcedureEndorsementError = AxiosError<{ message?: string; error?: string }>;

/**
 * Sends the procedures the office endorsed or renounced for the professional
 * with the end-of-day review.
 */
export function useSendProcedureEndorsement() {
  const dispatch = useDispatch();

  return useMutation<
    TSendProcedureEndorsementResponse,
    TSendProcedureEndorsementError,
    IProcedureEndorsementPayload
  >({
    mutationFn: async ({ endorsement, userId }) => {
      return await apiMethods[apiMethodsConst.SEND_PROCEDURE_ENDORSEMENT_REQUEST]({
        endorsement,
        userId,
      });
    },
    onError: (error) => {
      // Bridge: errorReducer turns any `*_FAILURE` into the ErrorShower dialog, the
      // channel the saga used. The app's one message slot stays free for the
      // review's own success or error dialog, which the same Send click raises.
      dispatch({ type: 'SEND_PROCEDURE_ENDORSEMENT_FAILURE', payload: error });
    },
  });
}
